"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var SummaryContext = /*#__PURE__*/React.createContext({});
var _default = SummaryContext;
exports.default = _default;